import { NoteColor as ApiNoteColor } from "~/graphql/types";
import { DEFAULT_NOTE_COLOR } from "~/constants";

import type { NoteColor } from "~/components/noteCard/NoteCard";

const NoteColorMap = new Map<string, ApiNoteColor>([
  ["white", ApiNoteColor.White],
  ["green", ApiNoteColor.Green],
  ["cyan", ApiNoteColor.Cyan],
  ["purple", ApiNoteColor.Purple],
  ["orange", ApiNoteColor.Orange],
  ["red", ApiNoteColor.Red],
  ["yellow", ApiNoteColor.Yellow],
]);

const ApiNoteColorMap = new Map<string, NoteColor>(
  Array.from(NoteColorMap).map((x) => x.reverse() as [ApiNoteColor, NoteColor]),
);

/**
 * Maps a note color to a valid API value.
 */
export function toApiNoteColor(value?: NoteColor | string | null) {
  return NoteColorMap.get(value ?? "") ?? NoteColorMap.get(DEFAULT_NOTE_COLOR);
}

/**
 * Maps an API note color to a valid prop value.
 */
export function toNoteColor(value?: ApiNoteColor | string | null) {
  return ApiNoteColorMap.get(value ?? "") ?? DEFAULT_NOTE_COLOR;
}
